<lib-modal-content [show]="isModal" id="mdl-ctn" (closeM)="send.emit(isModal = false)" >
  <div #profileCardContent class="mdl-container">
    <div class="mdl-ctn-closed">
      <button id="ic_closed" class="btn-closed" (click)="send.emit(isModal = false)">
        <svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
          <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="#2A2A2A"/>
        </svg>
      </button>
    </div>
    <div class="mdl-pfl">
      <img id="mdl-logo-lopes" src="../../../../assets/svgs/logo.svg" alt="Logo Lopes Brasil">
      <div class="mdl-img">
        <img *ngIf="dataForm.profile_image_url" id="mdl-img-profile" [src]="dataForm.profile_image_url" alt="Imagem Colaborador">
        <img *ngIf="!dataForm.profile_image_url" id="mdl-img-profile-default" [src]="profileDefault" alt="Imagem Default">
      </div>
      <div class="mdl-names">
        <div class="mdl-nntl" *ngIf="dataForm.name || dataForm.nickname">
          <div class="nname" 
          *ngIf="dataForm.nickname"
          [matTooltip]="dataForm.nickname"
          [matTooltipPosition]="'above'">
            {{ dataForm.nickname }}
          </div>
          <div class="tptp" 
          *ngIf="dataForm.name"
          [matTooltip]="dataForm.name"
          [matTooltipPosition]="'above'"
          [matTooltipClass]="'link-card-tooltip'"> 
            {{ dataForm?.name }}
          </div>
        </div>
        <span *ngIf="dataForm.technical_designation">{{ dataForm?.technical_designation }}</span>
      </div>
    </div>
    <div class="mdl-etp">
      <ul id="mdl-list-mdl-etp">
        <li id="mdl-item-etp" *ngIf="dataForm.creci">
          <svg id="ic-cc-creci" width="12" height="12" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.3333 13.6666H0.666667C0.489856 13.6666 0.320286 13.5963 0.195262 13.4713C0.0702379 13.3463 0 13.1767 0 12.9999V0.999919C0 0.823108 0.0702379 0.653538 0.195262 0.528514C0.320286 0.40349 0.489856 0.333252 0.666667 0.333252H11.3333C11.5101 0.333252 11.6797 0.40349 11.8047 0.528514C11.9298 0.653538 12 0.823108 12 0.999919V12.9999C12 13.1767 11.9298 13.3463 11.8047 13.4713C11.6797 13.5963 11.5101 13.6666 11.3333 13.6666ZM10.6667 12.3333V1.66659H1.33333V12.3333H10.6667ZM3.33333 4.99992H8.66667V6.33325H3.33333V4.99992ZM3.33333 7.66659H8.66667V8.99992H3.33333V7.66659Z" fill="#2A2A2A"/>
          </svg>
          <p class="mdl-icos">Creci:</p>
          <p class="mdl-data tpt">{{ dataForm?.creci }}</p>
        </li>
        <li id="mdl-item-etp" *ngIf="dataForm.company">
          <svg id="ic-cc-empresa" height="14" width="18" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.9998 10.6667H15.3332V12H0.666504V10.6667H1.99984V0.666667C1.99984 0.489856 2.07008 0.320286 2.1951 0.195262C2.32012 0.0702379 2.48969 0 2.6665 0H9.33317C9.50998 0 9.67955 0.0702379 9.80457 0.195262C9.9296 0.320286 9.99984 0.489856 9.99984 0.666667V10.6667H12.6665V5.33333H11.3332V4H13.3332C13.51 4 13.6796 4.07024 13.8046 4.19526C13.9296 4.32029 13.9998 4.48986 13.9998 4.66667V10.6667ZM3.33317 1.33333V10.6667H8.6665V1.33333H3.33317ZM4.6665 5.33333H7.33317V6.66667H4.6665V5.33333ZM4.6665 2.66667H7.33317V4H4.6665V2.66667Z" fill="#2A2A2A"/>
          </svg>   
          <p class="mdl-icos">Empresa:</p>
          <p class="mdl-data tpt" 
          [ngClass]="{'text-length': dataForm?.company.length > 21}"
          [matTooltip]="dataForm.company"
          [matTooltipPosition]="'above'"
          [matTooltipClass]="'link-card-tooltip'">
            {{ dataForm.company }}
          </p>
        </li>
      </ul>
    </div>
    <div class="mdl-links">
      <ul id="mdl-linkd-list">
        <li id="mdl-item-phone" *ngIf="dataForm.phone || dataForm.alternative_phone">
          <div class="data">
            <svg width="14" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.66683 1.66659V12.3333H8.3335V1.66659H1.66683ZM1.00016 0.333252H9.00016C9.17697 0.333252 9.34654 0.40349 9.47157 0.528514C9.59659 0.653538 9.66683 0.823108 9.66683 0.999919V12.9999C9.66683 13.1767 9.59659 13.3463 9.47157 13.4713C9.34654 13.5963 9.17697 13.6666 9.00016 13.6666H1.00016C0.823352 13.6666 0.653783 13.5963 0.528758 13.4713C0.403734 13.3463 0.333496 13.1767 0.333496 12.9999V0.999919C0.333496 0.823108 0.403734 0.653538 0.528758 0.528514C0.653783 0.40349 0.823352 0.333252 1.00016 0.333252ZM5.00016 10.3333C5.17697 10.3333 5.34654 10.4035 5.47157 10.5285C5.59659 10.6535 5.66683 10.8231 5.66683 10.9999C5.66683 11.1767 5.59659 11.3463 5.47157 11.4713C5.34654 11.5963 5.17697 11.6666 5.00016 11.6666C4.82335 11.6666 4.65378 11.5963 4.52876 11.4713C4.40373 11.3463 4.3335 11.1767 4.3335 10.9999C4.3335 10.8231 4.40373 10.6535 4.52876 10.5285C4.65378 10.4035 4.82335 10.3333 5.00016 10.3333Z" fill="#2A2A2A"/>
            </svg>
            <div class="mdl-info tpt">
              <p *ngIf="!isMobile && dataForm?.phone?.phone">{{ dataForm.phone.ddi }} {{ dataForm.phone.phone }}</p>
              <a *ngIf="isMobile && dataForm?.phone?.phone"  href="tel:{{ dataForm.phone.phone }}">   
                <span class="link-card">{{ dataForm.phone.ddi }} {{ dataForm.phone.phone }}</span>
              </a>
              <p class="mdl-spr" *ngIf="dataForm?.phone && dataForm?.alternative_phone?.phone">/</p>
              <p *ngIf="!isMobile && dataForm.alternative_phone && dataForm.alternative_phone.phone">{{ dataForm.alternative_phone.ddi }} {{ dataForm.alternative_phone.phone }}</p>
              <a *ngIf="isMobile && dataForm.alternative_phone && dataForm.alternative_phone.phone" href="tel:{{dataForm.alternative_phone.phone}}">
                <span class="link-card">{{ dataForm.alternative_phone.ddi }} {{ dataForm.alternative_phone.phone }}</span>
              </a>
            </div>
          </div>
        </li>
        <li id="mdl-item-email" *ngIf="dataForm.email">
          <div class="data">
            <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.00016 0H13.0002C13.177 0 13.3465 0.0702379 13.4716 0.195262C13.5966 0.320286 13.6668 0.489856 13.6668 0.666667V11.3333C13.6668 11.5101 13.5966 11.6797 13.4716 11.8047C13.3465 11.9298 13.177 12 13.0002 12H1.00016C0.823352 12 0.653782 11.9298 0.528758 11.8047C0.403734 11.6797 0.333496 11.5101 0.333496 11.3333V0.666667C0.333496 0.489856 0.403734 0.320286 0.528758 0.195262C0.653782 0.0702379 0.823352 0 1.00016 0ZM12.3335 2.82533L7.04816 7.55867L1.66683 2.81067V10.6667H12.3335V2.82533ZM2.0075 1.33333L7.04083 5.77467L12.0015 1.33333H2.0075Z" fill="#2A2A2A"/>
            </svg>
            <div class="mdl-info tpt">
              <a href="mailto:{{ dataForm.email }}" id="link-email-corretor">   
                <span class="link-card"
                [matTooltip]="dataForm.email"
                [matTooltipPosition]="'above'"
                [matTooltipClass]="'link-card-tooltip'">
                  {{ dataForm.email }}
                </span>
              </a>
            </div>
          </div>
        </li>
        <li id="mdl-item-st">
          <div class="data">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.00016 13.6666C3.31816 13.6666 0.333496 10.6819 0.333496 6.99992C0.333496 3.31792 3.31816 0.333252 7.00016 0.333252C10.6822 0.333252 13.6668 3.31792 13.6668 6.99992C13.6668 10.6819 10.6822 13.6666 7.00016 13.6666ZM5.4735 12.1113C4.81577 10.7161 4.43474 9.20673 4.3515 7.66659H1.70816C1.83789 8.69252 2.26278 9.65869 2.93121 10.4477C3.59964 11.2368 4.48284 11.8147 5.4735 12.1113ZM5.68683 7.66659C5.7875 9.29259 6.25216 10.8199 7.00016 12.1679C7.76838 10.7843 8.21713 9.24624 8.3135 7.66659H5.68683ZM12.2922 7.66659H9.64883C9.56558 9.20673 9.18455 10.7161 8.52683 12.1113C9.51749 11.8147 10.4007 11.2368 11.0691 10.4477C11.7375 9.65869 12.1624 8.69252 12.2922 7.66659ZM1.70816 6.33325H4.3515C4.43474 4.79311 4.81577 3.28371 5.4735 1.88859C4.48284 2.18517 3.59964 2.76309 2.93121 3.55212C2.26278 4.34114 1.83789 5.30732 1.70816 6.33325ZM5.6875 6.33325H8.31283C8.21666 4.75365 7.76814 3.21561 7.00016 1.83192C6.23195 3.21555 5.78387 4.7536 5.6875 6.33325ZM8.52683 1.88859C9.18455 3.28371 9.56558 4.79311 9.64883 6.33325H12.2922C12.1624 5.30732 11.7375 4.34114 11.0691 3.55212C10.4007 2.76309 9.51749 2.18517 8.52683 1.88859Z" fill="#2A2A2A"/>
            </svg>
            <div class="mdl-info tpt">
              <a href="{{uriLopes}}"  id="link-site-lopes" target="_blank">
                <span class="link-card"
                [matTooltip]="uri"
                [matTooltipPosition]="'above'"
                [matTooltipClass]="'link-card-tooltip'">
                  {{uri}}
                </span>
              </a>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</lib-modal-content>